(function () {
  const initialize = () => {
    const elm = document.querySelector('share-button');
    if (!elm) return;

    const shareElements = {
      shareButton: elm.querySelector('button'),
      shareSummary: elm.querySelector('summary'),
      closeButton: elm.querySelector<HTMLButtonElement>('.share-button__close'),
      successMessage: elm.querySelector<HTMLElement>('.share-button__message'),
      urlInput: elm.querySelector<HTMLInputElement>('input'),
      mainDetailsToggle: elm.querySelector<HTMLDetailsElement>('details'),
      buttonFallbackCopy: elm.querySelector<HTMLElement>('.share-button__copy')
    };

    const toggleDetails = () => {
      if (!shareElements.mainDetailsToggle?.open) {
        shareElements.successMessage?.classList.add('hidden');
        shareElements.closeButton?.classList.add('hidden');
        shareElements.shareSummary?.focus();
      }
    };

    const copyToClipboard = () => {
      if (!shareElements.urlInput) return;
      navigator.clipboard.writeText(shareElements.urlInput.value).then(() => {
        shareElements.successMessage?.classList.remove('hidden');
        shareElements.successMessage?.classList.add('flex');
        shareElements.closeButton?.classList.remove('hidden');
        shareElements.urlInput?.classList.add('hidden');
        shareElements.buttonFallbackCopy?.classList.add('hidden');
        shareElements.closeButton?.focus();
      });
    };

    const urlToShare = shareElements.urlInput
      ? shareElements.urlInput.value
      : document.location.href;

    if (navigator.share) {
      shareElements.mainDetailsToggle?.classList.add('hidden');
      shareElements.shareButton?.classList.remove('hidden');
      shareElements.shareButton?.addEventListener('click', () => {
        navigator.share({ url: urlToShare, title: document.title });
      });
    } else {
      console.log('Not share api');
      shareElements.mainDetailsToggle?.addEventListener(
        'toggle',
        toggleDetails
      );
      shareElements.mainDetailsToggle
        ?.querySelector('.share-button__copy')
        ?.addEventListener('click', copyToClipboard);
      shareElements.closeButton?.addEventListener('click', () => {
        shareElements.mainDetailsToggle?.toggleAttribute('open');
      });
    }
  };

  if (window.document.readyState === 'complete') {
    initialize();
  } else {
    window.addEventListener('load', initialize);
  }
})();
